export default "__VITE_ASSET__b1dd636d__"